/* eslint-disable camelcase */
const pt_br = {
    values: {
        'must not be empty': 'é obrigatório(a)',
        'Idle connection test period': 'Período de teste de conexão inativa',
        'in seconds': 'em segundos',
        'Validation query': 'Query de validação',
        'Max pool size': 'Tamanho máximo do pool de conexões',

        'SQL Events configuration': 'Configuração de Eventos SQL',
        'Add event type': 'Adicionar Event Type',
        'These event types will be retrieved directly from the SQL database when used in Pipes queries':
            'Estes eventos serão obtidos diretamente da base SQL quando utilizados em consultas Pipes',
        'Enable the instance as Storage to use this feature':
            'Habilite a instância como Armazenamento para usar essa funcionalidade',
        'Pipes event name': 'Nome do evento Pipes',
        'Query template': 'Template de query',
        'Valid placeholders on query template': 'Marcadores válidos no template de query',
        'Available fields': 'Campos disponíveis',
        'Pipes name': 'Nome no Pipes',
        'SQL Expression': 'Expressão SQL'
    }
}

module.exports = pt_br
